import Components from './../Component';
import Shepherd from 'shepherd.js';

export default class Walkthrough extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    this.tour = new Shepherd.Tour({
      styleVariables: {
        shepherdHeaderBackground: '#1E3368',
        shepherdThemePrimary: '#1E3368',
        shepherdTextBackground: '#1E3368',
        shepherdThemeTextHeader: '#ffffff',
        shepherdThemeTextPrimary: '#ffffff',
        shepherdThemeTextSecondary: '#ffffff',
        shepherdThemeTextColor: '#ffffff',
        useDropShadow: true
      },
      defaultStepOptions: {
        scrollTo: true
      },
      useModalOverlay: true,
      exitOnEsc: true,
    });

    this.addSteps(element);
    //this.tour.start();
  }

  addSteps(element) {

    let steps = element.querySelectorAll('[data-walkthrough-step]');
    let stepsLength = steps.length;

    if(stepsLength > 0) {
      steps.forEach( (step, index) => {
        let stepObject = JSON.parse(step.dataset.walkthroughStep);
        let options = {
          id: 'step-'+stepObject.id,
          tippyOptions: {
            arrow: false
          },
          text: stepObject.text,
          attachTo: {
            element: stepObject.target ? step.querySelectorAll(stepObject.target)[0] : step,
            on: stepObject.direction,
          }
        };
        if((index + 1) < stepsLength) {
          options.buttons = [
            {
              text: stepObject.btnNext ? stepObject.btnNext : 'Next',
              action: this.tour.next
            }
          ];
        } else {
          options.buttons = [
            {
              text: stepObject.btnNext ? stepObject.btnNext : 'Done',
              action: this.tour.complete
            }
          ];
        }
        if(stepObject.action) {
          options.buttons.action = eval(stepObject.action);
        }
        this.tour.addStep(options);
        console.log(this.tour);
      });
    }
  }

}